import { compact } from 'lodash';

export default angular
  .module('st.Integrations.ABNLookup', [])
  .service('ABNLookupService', ($http, dataService, ABNLOOKUP) => ({
    byName: (params) =>
      dataService
        .apiRequest(
          null,
          null,
          true,
          null,
          $http.post,
          ABNLOOKUP.API.ABN_LOOKUP_BY_NAME,
          params
        )
        .then((res) => compact([].concat(res))),
    byABN: async (params) =>
      dataService
        .apiRequest(null, null, true, null, $http.post, ABNLOOKUP.API.ABN_LOOKUP_BY_ABN, params)
        .then((res) => compact([].concat(res))),
    byACN: async (params) =>
      dataService
        .apiRequest(null, null, true, null, $http.post, ABNLOOKUP.API.ABN_LOOKUP_BY_ACN, params)
        .then((res) => compact([].concat(res)))
  }))
  .constant('ABNLOOKUP', {
    API: {
      ABN_LOOKUP_BY_NAME: '/api/v1/integration/abnLookup/name',
      ABN_LOOKUP_BY_ABN: '/api/v1/integration/abnLookup/abn',
      ABN_LOOKUP_BY_ACN: '/api/v1/integration/abnLookup/acn'
    }
  });
